import { useDispatch, useSelector } from 'react-redux';
import {
  submitLogin,
  submitGoogleAuth,
  fetchLogin,
  fetchUser,
  clearUser,
  preLogin,
  submitLoginSSO,
  submitSpearLogin,
} from '../../ducks/loginActions';

const useLogin = () => {
  const isLoginLoading = useSelector((state) => state.auth.ui.isLoginLoading);
  const isSSOLoginLoading = useSelector((state) => state.auth.ui.isSSOLoginLoading);
  const isSpearLoginLoading = useSelector((state) => state.auth.ui.isSpearLoginLoading);
  const isAuthenticated = useSelector((state) => state.auth.ui.isAuthenticated);
  const loginError = useSelector((state) => state.auth.ui.loginError);
  const googleError = useSelector((state) => state.auth.ui.googleError);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const ssoLoginError = useSelector((state) => state.auth.ui.ssoLoginError);
  const spearLoginError = useSelector((state) => state.auth.ui.spearLoginError);

  const dispatch = useDispatch();

  const handleLogin = (values) => {
    dispatch(submitLogin(values));
  };

  const handleLoginSSO = (values, registrationEnabled) => {
    dispatch(submitLoginSSO(values, registrationEnabled));
  };

  const handleSpearLogin = (tokens) => {
    dispatch(submitSpearLogin(tokens));
  };

  const handlePreLogin = (email, registrationEnabled) => {
    dispatch(preLogin(email, registrationEnabled));
  };

  const handleGoogleAuth = (values) => {
    dispatch(submitGoogleAuth(values));
  };

  const handleFetchUser = () => {
    dispatch(fetchLogin());
  };

  const handleFetchMe = () => {
    dispatch(fetchUser());
  };

  const clearCurrentUser = () => {
    dispatch(clearUser());
  };

  return {
    clearCurrentUser,
    currentUser,
    isSSOLoginLoading,
    isSpearLoginLoading,
    handleGoogleAuth,
    handleLogin,
    handleFetchUser,
    handleFetchMe,
    googleError,
    isLoginLoading,
    isAuthenticated,
    loginError,
    ssoLoginError,
    spearLoginError,
    handlePreLogin,
    handleLoginSSO,
    handleSpearLogin,
  };
};

export default useLogin;
